
import '../App.css';
import React from 'react';
import '../index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainRootClass from './Body';
import StandingsTableClass from './Standingsf1allday';
import ScheduleClass from './Schedulef1allday';
import HeadToHeadFunction from './HeadToHeadf1allday';

import RoughTestFunction from './RoughTests'

import AdminPageFunction from './Admin'
import ScheduleAdminPageFunction from './ScheduleAdmin'


function App() {
  return (
    
  <BrowserRouter>
    <Routes>
      <Route index element={<MainRootClass/>} />
      <Route path="home" element={<MainRootClass/>} />
      <Route path="standingstable" element={<StandingsTableClass/>} />
      <Route path="schedule" element={<ScheduleClass/>} />
      <Route path="head-to-head" element={<HeadToHeadFunction/>} />
      {/*<Route path="rough-test" element={<RoughTestFunction/>} />*/}
      <Route path="admin" element={<AdminPageFunction/>} />
      <Route path="admin-schedule" element={<ScheduleAdminPageFunction/>} />
      
    </Routes>
  </BrowserRouter>

);

}


export default App;